import TableData from './tabledata';
import NetworkData from './networkdata';
import {DatasetType} from './dataset';

/**
 * Create table data object from paragraph table type result
 */
export default class DatasetFactory {
  createDataset(datasetType) {
    switch (datasetType) {
      case DatasetType.NETWORK:
        return new NetworkData();
      case DatasetType.TABLE:
        return new TableData();
      default:
        throw new Error('Dataset type not found');
    }
  }
}
